var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.formComponent,{tag:"component",on:{"open-form":function($event){_vm.active = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }